import React from 'react';

//import components
import Email from '../footer/Email';
import Social from '../footer/Social';
import Navs from '../nav/Nav';
import Footer from '../footer/Footer';




export default class Projects extends React.Component {
    render() {
        return (
            <>
                <Navs />
                <Email />
                <Social />
                <Footer />   
            </>
        );
    }
}